import React, { useEffect, useRef, useState } from "react";
import View from "../View";
import DrawerDialog, { DrawerDialogRef } from "../DrawerDialog";
import './index.scss'
import { Button } from "antd";

const Picker = (props: {
    children: React.ReactNode,
    onChange: (value: any, index: number) => void,
    value: number,
    range: (number | string)[]
    title?: string
}) => {

    const drawerRef = useRef<DrawerDialogRef>();

    const [ckeckValue, setCheckValue] = useState<number>(props.value);

    useEffect(()=>{
        setCheckValue(props.value || 0)
    }, [props.value])

    return <>
        <View onClick={() => {
            drawerRef.current?.open()
        }}>{props.children}</View>
        <DrawerDialog
            ref={drawerRef}
            direction={0}
        >

            <View className="picker-title">{props.title || "请选择"}</View>
            <View className="picker-list-o">
                <View className="picker-list">
                    {(props.range || []).map((i, index) => {
                        return <span 
                        key={i}
                         className={`${ckeckValue === index ? 'active':''}`}
                         onClick={()=>{
                            setCheckValue(index)
                         }}
                         >{i}</span>
                    })}
                </View>
            </View>
            <View style={{
                display:'flex',
                justifyContent:"center",
                padding: "12px 0",
                width:"100%"
            }}>
                <Button size="large" style={{
                    // marginLeft: 16,
                    width: "42%"
                }}
                onClick={()=>{
                    drawerRef.current?.close()
                }}
                
                >取消</Button>
                <Button type='primary' size="large" style={{
                    marginLeft: 16,

                    width: "42%"
                }}
                onClick={()=>{
                    drawerRef.current?.close()
                    props.onChange(props.range[ckeckValue], ckeckValue)
                }}
                >确定</Button>
            </View>
        </DrawerDialog>
    </>
}

export default Picker;